import { auth } from "../firebaseConfigs";
import AccessCode from "../profile/models/AccessCode";


class AccessCodeService {
    static fetchCodes = async (): Promise<AccessCode[]> => {
        try {
            const token = await auth.currentUser?.getIdToken();

            const res = await fetch(`${process.env.REACT_APP_API_URL}/codes/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });
            const data: AccessCode[] = await res.json();
            console.log('Fetched codes:', data);
            return data;
        } catch (error) {
            console.error('Error fetching access codes:', error);
        }
        return [];
    };

    static deleteCode = async (code: AccessCode): Promise<boolean> => {
        try {
            const token = await auth.currentUser?.getIdToken();

            const res = await fetch(`${process.env.REACT_APP_API_URL}/codes/${code.id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (res.status !== 200) {
                console.error(`Failed to delete code: ${res.status}`);
            }
            return true;
        } catch (error) {
            console.error('Error deleting code:', error);
            return false;
        }
    };

    static updateCode = async (code: AccessCode): Promise<AccessCode | null> => {
        try {
            const token = await auth.currentUser?.getIdToken();

            const res = await fetch(`${process.env.REACT_APP_API_URL}/codes/${code.id}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(code),
            });

            if (res.status !== 200) {
                console.error(`Failed to update code: ${res.status}`);
                return null;
            }
            const data: AccessCode = await res.json();
            return data;
        } catch (error) {
            console.error('Error updating code:', error);
            return null;
        }
    }

    static createCode = async (code: AccessCode): Promise<AccessCode | null> => {
        try {
            const token = await auth.currentUser?.getIdToken();

            const res = await fetch(`${process.env.REACT_APP_API_URL}/codes/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(code),
            });

            if (res.status !== 200) {
                console.error(`Failed to create code: ${res.status}`);
                return null;
            }
            const data: AccessCode = await res.json();
            return data;
        } catch (error) {
            console.error('Error creating code:', error);
            return null;
        }
    }
}

export default AccessCodeService;
